import React from 'react';
import cn from 'classnames';
import style from 'components/common/Message/Message.module.scss';

export default function Message({children, withTriangle, className}) {
    const messageClasses = cn(style.messageWrapper, className, {
        [style.withTriangle]: withTriangle,
    });

    return <div className={messageClasses}>{children}</div>;
}
